require('../modules/web.dom-collections.for-each');

require('../modules/web.dom-collections.iterator');

require('../modules/web.immediate');

require('../modules/web.queue-microtask');

require('../modules/web.timers');

require('../modules/web.url');

require('../modules/web.url.to-json');

require('../modules/web.url-search-params');

var path = require('../internals/path');

module.exports = path;